import React from 'react';
import { Container, Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Hero from '../components/Hero';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import FAQImg from '../assets/images/hero-faq.jpg';
const sections = {
  General: [
    ['What areas do you serve?', 'Bloomington IN and nearby areas: Ellettsville, Bedford, Martinsville, and Spencer.'],
    ['Are you licensed and insured?', 'Yes. Our team is fully insured and maintains all required licenses.']
  ],
  Maintenance: [
    ['How often should I schedule maintenance?', 'Twice a year—once for cooling, once for heating. Commercial sites may need quarterly visits.'],
    ['What does a tune-up include?', 'Cleaning, safety checks, electrical tests, airflow verification, and performance benchmarking.']
  ],
  Repairs: [
    ['Do you charge diagnostic fees?', 'Yes, diagnostics start at $89 and are applied to the repair when approved.'],
    ['Is emergency service available?', 'Yes—24/7 emergency response across Bloomington and surrounding communities.']
  ],
  Costs: [
    ['Do you provide upfront pricing?', 'Always. We list options and get your approval before work begins.'],
    ['Do you offer financing?', 'Yes, for qualified projects such as replacements and major retrofits.']
  ],
  Installation: [
    ['How long does an installation take?', 'Most single-system swaps are completed in a day, complex jobs may take longer.'],
    ['Will you haul away old equipment?', 'Yes—responsible removal and refrigerant recovery are included.']
  ]
};

export default function FAQ() {
  const m = meta.faq;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Frequently Asked Questions" subtitle="Straight answers about HVAC service, maintenance, costs, and installation." bgImage={FAQImg}/>
      <Container maxWidth="md" sx={{ py: 6 }}>
        {Object.entries(sections).map(([group, items]) => (
          <Box key={group} sx={{ mb: 4 }}>
            <Typography variant="h2" gutterBottom>{group}</Typography>
            {items.map(([q,a], idx) => (
              <Accordion key={idx}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography>{q}</Typography></AccordionSummary>
                <AccordionDetails><Typography>{a}</Typography></AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
}
